import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";
import { siteMeta } from "@/mocks/siteMeta";

export default function FaqPreview() {
  const preview = faqs.slice(0, 4);

  return (
    <section aria-labelledby="faq-preview-title" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              id="faq-preview-title"
              eyebrow="FAQ"
              title="关于爆料91专区，你可能想问"
              description="专区怎么用、合集会更新到什么程度、内容从哪里来，常见问题集中收在这里。"
            />
            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="text-sm text-foreground-600 leading-relaxed">
                没找到答案？可以直接给编辑组发邮件，说明你遇到的问题或想看的栏目方向，
                我们会安排对应的栏目编辑跟进。
              </p>
              <a
                href={`mailto:${siteMeta.email}`}
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 cursor-pointer hover:gap-3 transition-all"
              >
                <i className="ri-mail-send-line"></i>
                {siteMeta.email}
              </a>
            </div>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1.5 h-11 px-5 rounded-md border border-foreground-300 text-sm text-foreground-900 whitespace-nowrap cursor-pointer hover:border-foreground-900 transition-colors"
            >
              查看全部常见问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-7">
            <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
          </div>
        </div>
      </div>
    </section>
  );
}